import { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { App } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';
import { toast } from 'sonner';

// ONLY the primary root landing and login screens should prompt to exit
const ROOT_ROUTES = ['/dashboard', '/auth/login', '/'];

export default function BackButtonHandler() {
  const location = useLocation();
  const navigate = useNavigate();
  const lastBackPressTime = useRef(0);

  useEffect(() => {
    if (!Capacitor.isNativePlatform()) return;

    const backButtonListener = App.addListener('backButton', () => {
      const currentPath = location.pathname;

      // 1. If user is on the main root screens, double-tap within 2s exits the app
      if (ROOT_ROUTES.includes(currentPath)) {
        const now = Date.now();
        if (now - lastBackPressTime.current < 2000) {
          App.exitApp();
        } else {
          lastBackPressTime.current = now;
          toast('Press back again to exit', { duration: 2000 });
        }
      } 
      // 2. If user is on ANY sub-screen (Profile, Capture, Lead Detail, Events, etc.), navigate back
      else {
        if (window.history.length > 1) {
          navigate(-1);
        } else {
          navigate('/dashboard', { replace: true });
        }
      }
    });

    return () => {
      backButtonListener.then((handler) => handler.remove());
    };
  }, [location.pathname, navigate]);

  return null;
}